




































































import Vue from '@front-app/vendor/vue';
import {
	computed,
	defineComponent,
	nextTick,
	PropType,
	ref,
	Ref,
} from '@vue/composition-api';
import { useIntersectionObserver } from '@vueuse/core';
import { PartialOrganization } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Size } from '@front-app/components/constants';
import { OrganizationsStore } from '@front-app/store/singletons/Organizations';
import { useRollingIndex } from '@front-app/components/search/useRollingIndex';
import { SearchOption, useOrganizationSearch } from '@front-app/components/search/useSearch';
import SearchBox from '@front-app/components/search/SearchBox.vue';
import SearchPlaceholder from '@front-app/components/search/SearchPlaceholder.vue';
import SearchOrganizationsResult from '@front-app/modules/organization/components/SearchOrganizationsResult.vue';
import SearchResult from '@front-app/components/search/SearchResult.vue';

let i = 0;
const uid = () => `search_orgs_${i++}`;

export default defineComponent({
	components: {
		FontAwesomeIcon,
		SearchBox,
		SearchPlaceholder,
		SearchOrganizationsResult,
		SearchResult,
	},
	props: {
		id: {
			type: String,
			required: false,
			default: '',
		},
		organizations: {
			type: Array as PropType<PartialOrganization[]>,
			required: true,
		},
		resultSize: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
		isLoading: Boolean,
	},
	setup(props, ctx) {
		const {
			searchString,
			results: filteredResults,
		} = useOrganizationSearch(computed(() => props.organizations));
		const limitedResults = computed(() => filteredResults.value.slice(0, 20));
		const el: Ref<null | Vue> = ref(null);
		const handleSearchItemClicked = async (organization: SearchOption<PartialOrganization>, e: Event): Promise<void> => {
			searchString.value = '';
			ctx.emit('select', organization, e.target);
			const elVal = el.value;
			if (!elVal) {
				return;
			}
			await nextTick();
			elVal.$el.querySelector('input')?.focus();
		};
		const theId = uid();
		const computedId = computed(() => (props.id ? props.id : theId));
		const emitCreate = () => {
			const target = document.getElementById(computedId.value);
			ctx.emit('create', searchString.value, target);
		};
		const searchFocus = useRollingIndex(limitedResults);
		const focusedSearchIdx = searchFocus.selectedIdx;
		const focusNextSearchResult = searchFocus.next;
		const focusPrevSearchResult = searchFocus.prev;
		const openFirstSearchResult = async (e: Event) => {
			if (limitedResults.value.length === 0) {
				emitCreate();
				return;
			}
			await handleSearchItemClicked(limitedResults.value[0], e);
		};

		// Organization details
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		const intersectionObserver = useIntersectionObserver(ref(null), () => {});
		const {
			get: getFullOrganization,
			isLoading: isLoadingFullOrganization,
			fetch: fetchFullOrganization,
		} = OrganizationsStore;

		const handleSearchInput = async (name: string) => {
			focusedSearchIdx.value = null;
			searchString.value = name;

			// Fallback logic if needed
			if (!intersectionObserver.isSupported && limitedResults.value.length <= 20) {
				limitedResults
					.value
					.map(({ original }) => fetchFullOrganization(original.id));
			}
		};

		return {
			el,
			computedId,
			emitCreate,
			handleSearchItemClicked,
			filteredResults,
			limitedResults,
			searchString,
			handleSearchInput,
			focusedSearchIdx,
			focusNextSearchResult,
			focusPrevSearchResult,
			openFirstSearchResult,
			// Organization full details
			getFullOrganization,
			isLoadingFullOrganization,
			fetchFullOrganization,
			// Util
			Size,
		};
	},
});
